import React from 'react';
import styled from 'styled-components';
import { BaseConfetti } from 'elements/confetti/confetti.styles'
import { layout } from 'styles/layout'

const AnimatedConfetti = styled(BaseConfetti)`
  z-index: -1;
  animation: display-in 2s linear 1;
`

export const Confetti1 = styled(AnimatedConfetti).attrs({
  width: '21',
  height: 26,
  viewBox: '0 0 21 26',
  children: <path d="M16.6451 22.6177L2.19935 2.00396L19.6917 5.03461L16.6451 22.6177Z" stroke="#FF7062" strokeWidth="2" strokeLinejoin="round"/>
})`
  display: none;

  @media all and (min-width: ${layout.subLg}) {
    display:  block;
    top: 15%;
    right: 17.25%;
    transform: rotate(-89deg) scale(.81);
  }
`

export const Confetti2 =  styled(AnimatedConfetti).attrs({
  width: '26',
  height: 36,
  viewBox: '0 0 26 36',
  children: <path d="M12.6777 35.3549L25.1831 22.7363L25.1831 12.505L12.6777 5.34058e-05L0.17244 12.505L0.172419 22.7362L12.6777 35.3549Z" fill="#FFDF6E"/>
})`
  top: -0.5%;
  right: 4%;
  transform: rotate(-37deg) scale(.61);
  filter: invert(1) hue-rotate(55deg) brightness(1.05) saturate(1.15);

  @media all and (min-width: ${layout.subLg}) {
    top: 6.5%;
    left: 65%;
    right: initial;
    transform: rotate(-37deg) scale(.81);
  }
`

export const Confetti3 =  styled(AnimatedConfetti).attrs({
  width: 24,
  height: 38,
  viewBox: '0 0 24 38',
  children: <path d="M19.3713 37.4744L23.7889 2.56197L9.82397 0.794923L0.569806 7.97017L19.3713 37.4744Z" fill="#FFDF6E"/>
})`
  left: 5.35%;
  top: 5.05%;
  transform: rotate(284deg) skew(10deg, 10deg) scale(.81);
  filter: hue-rotate(146deg) brightness(.68) saturate(1.5);
  animation: display-in 2s linear 1;

  @media all and (min-width: ${layout.subLg}) {
    left: 51.35%;
    top: 9.05%;
    transform: rotate(63deg) skew(10deg,10deg) scale(.81);
  }
`
